<template>
  <div class="iframeClass">
    <iframe class="iframeClass" id="iframe" :src="visualSrc" frameborder="0" width="100%" height="100%" />
  </div>
</template>
<script>
import api from '@dss/js/service/api';
import util from '../../../util/index';
import {NODETYPE} from '@dss/js/service/nodeType';
import { ROOT_SERVER } from "@/api";

export default {
  props: {
    parametes: {
      type: [String, Object],
      default: null
    },
    node: {
      type: [String, Object],
      default: null
    },
  },
  data() {
    return {
      height: 1200,
      visualSrc: '',
      ROOT_SERVER,
    };
  },
  mounted() {
    this.node.jobContent = this.node.jobContent || {}
    this.getUrl();
    window.addEventListener('message', this.msgEvent, false)
  },
  methods: {
    getUrl() {
      // 节点url由后台返回，只用定义变量,和后台同步命名
      const projectId = this.parametes.projectID;
      const nodeId = this.node.jobContent && this.node.jobContent.id;
      api.fetch('dss/getAppJointProjectID', {
        projectID: projectId,
        nodeType: this.node.nodeType
      }, 'get').then(res => {
        const url = util.replaceHolder(this.node.jumpUrl, {
          ...this.node.jobContent,
          nodeId: nodeId || this.node.key,
          projectId: res.appJointProjectID,
          nodeName: this.node.title
        });
        this.visualSrc = url;
      })

    },
    sendmessage() {
      //统一放到index页面做
      // if(this.node.type === NODETYPE.EXCHANGE){
      //   let iframe = document.getElementById("iframe").contentWindow;
      //   iframe.postMessage(document.cookie, ROOT_SERVER);
      //   console.log("!!!!!send message to iframe:",document.cookie);
      // }
    },
    msgEvent(e) {
      if(e.data) {
        let data = JSON.parse(e.data)
        if (data.type === 'qualitis' && data.nodeId === this.node.key) {
          //jumpURL = "http://192.168.170.187:8090/#/addgrouptechniquerule?tabletype=1&id=${projectid}&rulegroupid=${rulegroupid}&nodeid=${nodeid}&dssurl=${dssurl}&cookies=${cookies}"
          if(data.data.action === 'add') {
            this.node.jobContent.ruleGroupId = data.data.ruleGroupId
          } else if(data.data.action === 'delete') {
            this.node.jobContent.ruleGroupId = ''
          }
        }
        //exchgis节点保存job成功，发送回jobId，存入node
        if (data.type === NODETYPE.EXCHANGE && data.key === "flowNode") {
          this.node.jobContent.jobId = data.jobId

          // this.node.resources = this.node.resources || [];
          // if(this.node.resources.length <= 0){
          //   this.node.resources[0] = new Object();
          // } 
          // this.node.resources[0].resourceId = data.jobId;
          // this.node.resources[0].version= "v000001" ;
        }
      }
      this.$emit('save', {}, {...this.node})
    },
  },
  beforeDestroy() {
    window.removeEventListener('message', this.msgEvent, false)
  }
};

</script>
<style lang="scss" scoped>
  .iframeClass {
    position: relative;
    height: 100%;
    width: 100%;
  }

</style>
